module.exports = __webpack_public_path__ + "img/guigeliao6.776df53d.jpg";